import { FC } from 'react'
import styled from 'styled-components'
import { useSetRecoilState } from 'recoil'
import { inputState, isInViewFooterState, stepState } from '../../../states/messageState'
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { useSubmitInquiry } from '../../../hooks/useSubmitInquiry'
//components
import { FooterContent } from '../FooterContent'
import { Button } from '../../Button'

export const ChooseChangeAddress: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const setInput = useSetRecoilState(inputState)
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  /**住所変更可否によってそのまま申請or住所入力 */
  const handleSubmitChooseAddress = async (isChangeAddress: boolean) => {
    setIsInViewFooter(false)
    setInput('')
    await handleAddSenderParent('user', isChangeAddress ? 'はい' : 'いいえ')

    //住所の変更がある場合、APIリクエストせず郵便番号を更新するステップへ
    if (isChangeAddress) {
      await handleAddSenderParent('bot', `郵便番号(ハイフン無し)を入力してください`)
      handleInViewFooter()
      setCurrentStep('inputShippingAddress')
      return
    }
    //住所の変更がない場合、画像アップロードへ
    await handleAddSenderParent(
      'bot',
      `故障した商品の状態が分かるように画像を3枚までアップロードしてください。\n※JPGまたはPNG\n※画像サイズは15MB以下`
    )
    handleInViewFooter()
    setCurrentStep('uploadImage')
  }

  return (
    <FooterContent isWide={false}>
      <FlexWrap>
        <Button buttonType="outlined" onClick={() => handleSubmitChooseAddress(false)}>
          いいえ
        </Button>
        <Space size={20} />
        <Button buttonType="outlined" onClick={() => handleSubmitChooseAddress(true)}>
          はい
        </Button>
      </FlexWrap>
    </FooterContent>
  )
}

const FlexWrap = styled.div`
  display: flex;
`
const Space = styled.div<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: 1px;
`
